'use client';

import { ReactNode } from 'react';
import { Button } from '@/shared/components/Button';
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogDescription,
	DialogFooter,
} from './Dialog';

interface InfoDialogProps {
	isOpen: boolean;
	onClose: () => void;
	title: string;
	description: ReactNode;
	closeButtonText: string;
}

export function InfoDialog({
	isOpen,
	onClose,
	title,
	description,
	closeButtonText,
}: InfoDialogProps) {
	return (
		<Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
				</DialogHeader>

				<DialogDescription>{description}</DialogDescription>

				<DialogFooter>
					<Button
						variant="ghost"
						onClick={onClose}
						className="text-white/80 hover:bg-white/10"
					>
						{closeButtonText}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
